/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define([
    "i18n/i18n",
    "component!base",
    "component!list",
    "client/views/tree",
    "component!mustache",
    "utils/dom",
    "jquery",
    "underscore",
    "backbone",
    "saveAs",
    "utils/clone",
    'client/editor',
  ],
  function(
    i18n,
    Base,
    ListTemplate,
    TreeView,
    MustacheTemplate,
    dom,
    $,
    _,
    Backbone,
    saveAs,
    deepClone
) {
var ListView = ListTemplate.View;

var AddItemView = MustacheTemplate.View.extend({

  events: {
    "click .mb-create": "create",
    "click .add-module": "create",
    "click .mb-group-item": "toggleChildren",
    "sortinsert": "sortInsert",
    'click .edit-module': 'onEditModuleButtonClick',
    'click .delete-module': 'onRemoveModuleButtonClick'
  },

  sortInsert: function (e, ui) {
    var parent = document.createElement("div");
    this.create(e, { 
        el: parent
      },
      null
    );
    var created = $(parent).children();
    ui.replaceWith(created);
    ui = created;
  },
  
  setEditable: function (editable) {
  },

  doInstrument: function () {
    return false;
  },

  toggleChildren: function () {
    this.model.set("toggleOpen", !this.model.get("toggleOpen"));
  },

  create: function (e, parent, insertBefore) {
    this.options.parent.options.application.hidePicker();
    this.model.create(
      this.options.parent.options.application,
      parent || this.options.parent.options.parent,
      typeof insertBefore === "undefined" ? this.options.parent.options.insertBefore : insertBefore
    );
  },

  initialize: function () {
    var that = this;
    var imageBasePath = this.options.application && this.options.application.options.designerImageBasePath || "";
    var isModulesTab = this.model.attributes.templateType === 'module';
    var isParent = this.model.get("children");
    var buttonHtml = isModulesTab  && !isParent ?
      '<div class="module-action-buttons">\
        <button class="add-module">\
          <i class="icon-plus"></i>\
        </button>\
        <button class="edit-module">\
          <i class="icon-pencil"></i>\
        </button>\
        <button  class="delete-module">\
          <i class="fa fa-trash"></i>\
        </button>\
      </div>': "";

    
    this.options.templateString = this.options.templateString || "<div class=\"editor-selection\"><div class=\"editor-selection-content {{#children}}mb-group-item{{/children}}{{^children}}mb-create{{/children}}\" {{option_attributes}}>{{#children}}{{#localizedName}}{{localizedName}}{{/localizedName}}{{/children}}{{^children}}<div>{{#icon}}<img src=\"" + imageBasePath + "{{{icon}}}\">{{/icon}}<p  title=\"{{#isFilterFacets}}{{name}}{{/isFilterFacets}}\">{{#localizedName}}{{localizedName}}{{/localizedName}}{{^localizedName}}{{{name}}}{{/localizedName}}</p>{{#description}}<small><i class=\"fas fa-info-circle\"></i> <span title=\"{{description}}\">{{description}}</span></small>{{/description}}</div>{{/children}}</div> "+ buttonHtml +" </div>";
    MustacheTemplate.View.prototype.initialize.apply(this, arguments);

    // Do not make a parent draggable
    if (isParent) {
      this.el.className += " mb-category-has-children";

    } else {
      this.el.className += " mb-category-entry";
      window.createMode = false;
      this.$el.draggable({
        connectToSortable: this.options.parent.options.sortables,
        tolerance: "pointer",
        helper: "clone",
        appendTo: "body",
        start: that.startDragging,
        stop: that.stopDragging.bind(that),
        cursorAt: { top: 10, left: 10 } 
      });
    }
  },

  onEditModuleButtonClick: function(e) {
    // TODO: set the appfragment of the applicaiton
    e.stopPropagation();
    var editor = this.options.application.editor;
    // get the 
    
    var appFragment = this.model.attributes.appFragment;
    editor.loadAppFragment(appFragment, {clear: true});
  },

  onRemoveModuleButtonClick: function(e) {
    // TODO: set the appfragment of the applicaiton
    e.stopPropagation();


    
    var editor = this.options.application.editor;
    // get the 
    
    var appFragment = this.model.attributes.appFragment;
    if (!confirm("Are you sure to remove fragment " + appFragment.title + " (id=" + appFragment.id + ")?")) {
      return;
    }
    editor.removeAppFragment(appFragment, {clear: true});
  },

    
  startDragging: function () {
    $('body').addClass("mb-dragging");
  },

  stopDragging: function (e , ui) {
    if (!ui.helper.parent().get(0).classList.contains("ui-sortable")) return;
    this.sortInsert(e, ui.helper);
    $('body').removeClass("mb-dragging");
  }
});

var AdderGroupView = Backbone.View.extend({
    tagName: "li",
    
    events: {
      "click": "select"
    },

    select: function () {
      this.options.parent.selectGroup(this.model);
    },

    render: function () {
      this.el.innerHTML = i18n(this.model.get("name"));

      return this;
    }

});

var AdderGroupsView = ListView.extend({
    tagName: "ul",
    className: "nav nav-stacked",
    childView: AdderGroupView,

    selectGroup: function (group) {
      this.options.delegate && this.options.delegate.selectGroup && this.options.delegate.selectGroup(group);
    },

    setEditable: function (editable) {
    }

});


var SelectionView = ListView.extend({

  initialize: function () {
    var that = this;
    let filterContainer = this.el;

    if (filterContainer.classList.contains('filteredfacet') || filterContainer.classList.contains('module')) {
      // For filters we want to use a treeview instead of a listview
      var tree = new TreeView({
        application: this.options.application,
        entryTagName: "div",
        entryClassName: "filter-designer-group",
        model: this.model,
        parent: this,
        childView: AddItemView,
        childrenPath: "children",
        toggleChildrenOption: "toggleOpen",
        elementTemplate: this,
      });
      filterContainer.prepend(tree.el);
    } else {
      ListView.prototype.initialize.apply(this, arguments);
    }
    
    if (filterContainer.classList.contains('filteredfacet') || filterContainer.classList.contains('module')) {
      let searchContainer = document.createElement('div');
      searchContainer.classList.add('filter-search-container');

      let searchfilterInput = document.createElement('input');
      searchfilterInput.classList.add('filter-search-input');
      searchfilterInput.setAttribute('type', 'text');

      if (filterContainer.classList.contains('filteredfacet')) {
        searchfilterInput.setAttribute(
          'placeholder', 
          i18n("search_by_filter_name")
        );
      } else {
        searchfilterInput.setAttribute(
          'placeholder', 
          i18n("search_by_module_name")
        );
      }

      let searchfilterInputIcon = document.createElement('i');
      searchfilterInputIcon.classList.add('icon-search');

      let timeout = null, inputValue = '', inputTarget;

      searchfilterInput.addEventListener("input", function (event) {
        clearTimeout(timeout);
        inputTarget = event.target;
        timeout = setTimeout(function () {
          inputValue = inputTarget.value.toLowerCase();

          var models = that.model.models;
          _.each(models, function(model, index) {
            var toggleOption = "toggleOpen";
            var isOpen = model.get(toggleOption);
            if (!inputValue && index === 0) {
              // open first group
              model.set(toggleOption, true);
            } else if (!inputValue && index !== 0) {
              // close all other groups
              model.set(toggleOption, false);
            } else if (!isOpen) {
              // on search open all groups
              model.set(toggleOption, true);
            }
          });

          _.each(filterContainer.querySelectorAll("p"), function (element) {
            if (inputValue === ''){
              $(element.closest('.filter-designer-group')).show();
            } else if ((element.innerHTML).toLowerCase().includes(inputValue) || element.getAttribute("title").toLowerCase().includes(inputValue)){
              $(element.closest('.filter-designer-group')).show();
            } else {
              $(element.closest('.filter-designer-group')).hide();
            }
          });
        }, 500);
      });


      searchContainer.append(searchfilterInput);
      searchContainer.append(searchfilterInputIcon);

      if (filterContainer.classList.contains('module')) {
        var persistedStore = that.options.application.clientExtensions.getReadonlyAppFragmentStoreV1();

        var exportModulesBtn = document.createElement('button');
        exportModulesBtn.classList.add('btn');
        exportModulesBtn.classList.add('modules-action-btn');
        exportModulesBtn.textContent  = i18n('editor_export');
        searchContainer.append(exportModulesBtn);

        var cloneModulesBtn = document.createElement('button');
        cloneModulesBtn.classList.add('btn');
        cloneModulesBtn.classList.add('modules-action-btn');
        cloneModulesBtn.textContent  = i18n('editor_clone');
        if (persistedStore) searchContainer.append(cloneModulesBtn);

        exportModulesBtn.addEventListener('click', () => {
          var allAppFragments = [];
          that.model.each(function(groupModel) {
            if (!groupModel.get('children').each) return;
            groupModel.get('children').each(function(item){
              allAppFragments.push(item.get('appFragment'));
            });
          });
          const jsonString = JSON.stringify(allAppFragments);

          const jsonBlob = new Blob([jsonString], { type: "application/json" });
          saveAs(jsonBlob, 'modules.json');
        });

        cloneModulesBtn.addEventListener('click', () => {
          var allAppFragments = [];
          that.model.each(function(groupModel) {
            if (!groupModel.get('children').each) return;
            groupModel.get('children').each(function(item){
              allAppFragments.push(item.get('appFragment'));
            });
          });
          
          const collectionName = prompt(i18n('editor_enter_collection_name'));

          if (collectionName) {
            cloneModulesBtn.disabled = true;
             allAppFragments.forEach(function(appFragment) {
              var cloneAppFragment = deepClone(appFragment);
              delete cloneAppFragment.id;
              persistedStore.create(appFragment, {
                persistedResourcesAppFragmentStoreCollection: collectionName,
                application: that.options.application
              });
            });
            cloneModulesBtn.disabled = false;
          }
        });
      }

      filterContainer.prepend(searchContainer);
    }
  },
    
  childView: AddItemView,

  setEditable: function (editable) {
  }

});

var AdderGroupHeaderView = MustacheTemplate.View.extend({

  className: "mb-group",

  setEditable: function (editable) {
  },

  create: function (e) {
    this.model.create(this.options.parent.options.application, this.options.parent.options.parent, this.options.parent.options.insertBefore);
  },

  initialize: function () {
    this.options.templateString = "<a name=\"adder_{{id}}\"></a><span>{{{name}}}</span>{{#description}}<div class=\"editor-description\"><p>{{{description}}}</p></div>{{/description}}";
      MustacheTemplate.View.prototype.initialize.apply(this, arguments);
    }
  });


  var AdderView = Base.extend({

    events: {
      "click .close": "remove"
    },

    initialize: function () {
      Base.prototype.initialize.apply(this, arguments);

      this.groupsView = new AdderGroupsView(_.extend({delegate: this}, this.options));

      this.categoriesView = new CategoriesView(_.extend(
        this.options,
        {
          model: this.model
        }
      ));

    },

    className: "editor",

    selectGroup: function (group) {
    },
    
    setEditable: function (editable) {
    },

    render: function () {
      return this.categoriesView;
    }
  });

  var CategoriesViewEntryView = Base.extend({

    render: function () {
      var that = this;
      this.el.innerHTML = "";
      this.el.className = "category-entry ";      
      $(this.el).click(function () {
        that.displayCategoryDetails(that.model);
        that.options.application.options.activeTabID = that.model.get("id");
        that.setActiveCategory();
      });

      this.appendChild(new AdderGroupHeaderView({
        model: this.model
      }).render().el);

      // select first category
      if (!this.options.application.options.activeTabID) {
        this.displayCategoryDetails(this.model);
        this.options.application.options.activeTabID = this.model.get("id");
        this.setActiveCategory();
      }
      
      if (this.options.application.options.activeTabID === this.model.get("id")) {
        this.displayCategoryDetails(this.model);
        this.setActiveCategory();
      }
      
      return this;
    },

    getContainerWrappedElementByGivenElement: function(element) {
      if (element) {
        return $(this.options.application.options.containerEl).find(element);
      }
      return this.options.application.options.containerEl;
    },

    setActiveCategory: function () {
      this.getContainerWrappedElementByGivenElement('.category-entry').removeClass("active");
      $(this.el).addClass("active");
      var isModuleTabActive = this.model.attributes.name === "editor_modules";
      $('body').toggleClass("module-tab", isModuleTabActive);
    },

    displayCategoryDetails: function (model, id) {
      var detailsContainer = new SelectionView(
        _.extend(
          {},
          this.options.parent.options,
          {
            model: model.get("adders"),
            className: function() {
              var componentName = model.get("id");
              var parsedComponentName = componentName.replace(/\s/g, '_');

              var id = model.get("groupId");              
              var parsedID = id.replace(/\s/g, '_');
              return parsedID + ' ' + parsedComponentName;
            }
          }
        )).render().el;

      detailsContainer.setAttribute('data-template-name', model.get('groupId'));
      this.getContainerWrappedElementByGivenElement('#categoryDetails').html("").append(detailsContainer);
    },

    setEditable: function (editable) {
    }

  });

  var CategoriesView = ListView.extend({
    tagName: "div",
    className: "mb-editor-categories",
    childView: CategoriesViewEntryView,

    selectGroup: function (group) {
      this.options.delegate && this.options.delegate.selectGroup && this.options.delegate.selectGroup(group);
    },

    setEditable: function (editable) {
    }

  });

  AdderView.AddItemView = AddItemView;
  AdderView.AdderGroupView = AdderGroupView;
  AdderView.AdderGroupsView = AdderGroupsView;
  AdderView.SelectionView = SelectionView;
  AdderView.AdderGroupHeaderView = AdderGroupHeaderView;
  AdderView.CategoriesViewEntryView = CategoriesViewEntryView;
  AdderView.CategoriesView = CategoriesView;

  return AdderView;
});
